import { render, staticRenderFns } from "./TextAlignmentForm.vue?vue&type=template&id=4aaf487f"
import script from "./TextAlignmentForm.vue?vue&type=script&lang=js"
export * from "./TextAlignmentForm.vue?vue&type=script&lang=js"
import style0 from "./TextAlignmentForm.vue?vue&type=style&index=0&id=4aaf487f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports